export const normalizePestanya = (value) => String(value || '').trim().toLowerCase();

export const isCaixaEmpty = (posicions, caixaId) => {
    if (!caixaId || caixaId === -1) return false;
    return !Object.prototype.hasOwnProperty.call(posicions?.caixes || {}, caixaId);
};

export const buildSuggestionPayload = ({
    selectedEvent,
    selectedBundle,
    selectedVersio,
    caixaId,
    pestanya,
}) => {
    const eventId = parseInt(selectedEvent, 10);
    const bundleId = String(selectedBundle || '').trim();
    const versio = String(selectedVersio || '').trim();
    const normalizedPestanya = normalizePestanya(pestanya);

    if (Number.isNaN(eventId) || !bundleId || !versio || !caixaId || caixaId === -1 || !normalizedPestanya) {
        return null;
    }

    return {
        eventId,
        bundleId,
        versio,
        caixaId: String(caixaId),
        pestanya: normalizedPestanya,
    };
};

export const buildCopilotContextKey = ({
    eventId,
    bundleId,
    versio,
    pestanya,
}) => `${eventId}.${bundleId}.${versio}.${normalizePestanya(pestanya)}`;

export const buildCopilotLocalSnapshotKey = ({
    posicions,
    assistenciesEvent,
}) => {
    const caixes = posicions?.caixes || {};
    const castellers = posicions?.castellers || {};

    const positionsSlice = {
        caixes,
        castellers,
    };

    const assistenciesSlice = Array.isArray(assistenciesEvent)
        ? [...assistenciesEvent]
            .map(item => ({
                id: parseInt(item?.id, 10),
                assistencia: parseInt(item?.assistència ?? item?.assistencia, 10),
                dataEntrada: item?.['data-entrada'] || item?.dataEntrada || null,
                dataSortida: item?.['data-sortida'] || item?.dataSortida || null,
            }))
            .filter(item => !Number.isNaN(item.id))
            .sort((a, b) => a.id - b.id)
        : [];

    return JSON.stringify({
        positionsSlice,
        assistenciesSlice,
    });
};

const getAssistenciaForCasteller = (assistenciesEvent, castellerId) => {
    if (!Array.isArray(assistenciesEvent)) return null;

    const matched = assistenciesEvent.find(item => parseInt(item?.id, 10) === parseInt(castellerId, 10));
    return matched?.assistencia || null;
};

const isCastellerCurrentlyAvailable = ({ castellerId, posicions, assistenciesEvent }) => {
    const parsedId = parseInt(castellerId, 10);
    if (Number.isNaN(parsedId)) return false;

    if (Object.prototype.hasOwnProperty.call(posicions?.castellers || {}, parsedId)) {
        return false;
    }

    const assistencia = getAssistenciaForCasteller(assistenciesEvent, parsedId);
    if (assistencia && !['Vinc', 'Fitxat'].includes(assistencia)) {
        return false;
    }

    return true;
};

export const pickBestSuggestionFromList = ({
    rankedCastellerIds,
    posicions,
    assistenciesEvent,
}) => {
    if (!Array.isArray(rankedCastellerIds) || rankedCastellerIds.length === 0) return null;

    for (let i = 0; i < rankedCastellerIds.length; i += 1) {
        const candidateId = parseInt(rankedCastellerIds[i], 10);
        if (Number.isNaN(candidateId)) continue;

        if (isCastellerCurrentlyAvailable({
            castellerId: candidateId,
            posicions,
            assistenciesEvent,
        })) {
            return candidateId;
        }
    }

    return null;
};

export const pickBestSuggestionFromRanking = ({
    caixaId,
    rankingsByCaixa,
    posicions,
    assistenciesEvent,
}) => {
    if (!caixaId || !rankingsByCaixa || typeof rankingsByCaixa !== 'object') return null;

    return pickBestSuggestionFromList({
        rankedCastellerIds: rankingsByCaixa[String(caixaId)],
        posicions,
        assistenciesEvent,
    });
};

export const isSuggestionStillApplicable = ({
    suggestion,
    caixaSelected,
    posicions,
    assistenciesEvent,
}) => {
    if (!suggestion) return false;
    if (String(caixaSelected) !== String(suggestion.caixaId)) return false;
    if (!isCaixaEmpty(posicions, suggestion.caixaId)) return false;

    const suggestedCastellerId = parseInt(suggestion.suggestedCastellerId, 10);
    if (Number.isNaN(suggestedCastellerId)) return false;

    if (Object.prototype.hasOwnProperty.call(posicions?.castellers || {}, suggestedCastellerId)) {
        return false;
    }

    const assistencia = getAssistenciaForCasteller(assistenciesEvent, suggestedCastellerId);
    if (assistencia && !['Vinc', 'Fitxat'].includes(assistencia)) {
        return false;
    }

    return true;
};
